import ShiftPostToTarget from 'app/modules/posts/components/shiftPosts/shiftTargetProfilesSelect/ShiftPostToTarget';
import {
  ShiftPostsTarget,
  ShiftPostsTargetHandlers,
  ShiftPostsVariant,
} from 'app/modules/posts/hooks/useShiftPosts';
import { FC } from 'react';
import { PageData } from 'types/Page';
import { ListPost } from 'types/PostDetail';

type PostsCustomSchedule = Record<
  number,
  {
    customScheduleDate?: string;
    customScheduleTime?: string;
  }
>;

type Props = {
  targets: ShiftPostsTarget[];
  removeTarget(id: string): void;
  targetHandlers: ShiftPostsTargetHandlers;
  errors: Record<string, ShiftPostsTargetValidationError>;
  variant: ShiftPostsVariant;
  availablePages: PageData[];
  dataNamePrefix?: string;
  selectedPosts: ListPost[];
  shiftDays?: number;
  postsCustomSchedule?: PostsCustomSchedule;
};

export type ShiftPostsTargetValidationError = {
  id: string;
  profileId: string | undefined;
  projectId: string | undefined;
};

const ShiftTargetProfilesSelect: FC<Props> = ({
  targets,
  removeTarget,
  targetHandlers,
  errors,
  variant,
  availablePages,
  dataNamePrefix = 'posts',
  selectedPosts,
  shiftDays,
  postsCustomSchedule,
}) => {
  // reset target handlers on each render
  targetHandlers.current = {};
  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      {targets.map((target, index) => (
        <ShiftPostToTarget
          selectedPosts={selectedPosts}
          availablePages={availablePages}
          variant={variant}
          key={target.id}
          error={errors[target.id]}
          targetNumber={index + 1}
          initialTarget={target}
          onRemoveTarget={
            targets.length > 1 ? () => removeTarget(target.id) : undefined
          }
          dataNamePrefix={`${dataNamePrefix}_${variant}-target`}
          shiftDays={shiftDays}
          postsCustomSchedule={postsCustomSchedule}
          ref={(ref) => {
            if (ref) targetHandlers.current[target.id] = ref;
          }}
        />
      ))}
    </div>
  );
};

export default ShiftTargetProfilesSelect;
